import React, { type FC, useMemo } from 'react';
import { ListItem, Thumbnail } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { Creative } from 'packages/store/creatives/types';
import { contentIconMap } from 'packages/pages/components/card/utils';
import { DesignsListRoot, IconWrapperElement, Spacing } from './DesignsList.styled';
import { ExportResult } from './types';

type DesignsListProps = {
    designs: Creative[];
    exportResults: ExportResult[];
};

const DesignsList: FC<DesignsListProps> = ({ designs, exportResults }) => {
    const { translate } = useTranslate();

    const exportResultMap = useMemo(() => {
        const map = new Map<number, ExportResult>();
        exportResults.forEach((result) => {
            map.set(result.designId, result);
        });

        return map;
    }, [exportResults]);

    return (
        <DesignsListRoot>
            <Spacing />
            {designs.map((design) => (
                <ListItem
                    thumbnail={
                        <Thumbnail variant="content" imageUrl={design.thumbnailImage}>
                            {(design.videosCount === 0 || exportResultMap.get(design.id)?.success === false) && (
                                <Thumbnail.Indicator type="error" />
                            )}
                        </Thumbnail>
                    }
                    key={design.id}
                    subtext={translate('modal.bulk-export.design.subtext', {
                        pageCount: design.pageCounts,
                        variationCount: design.videosCount,
                    })}
                    rightElements={<IconWrapperElement>{contentIconMap[design.creativeType]}</IconWrapperElement>}
                >
                    {design.name}
                </ListItem>
            ))}
            <Spacing />
        </DesignsListRoot>
    );
};

export default DesignsList;
